import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.backgroundMuted,
    },
    margin16: {
      margin: 16,
    },
    marginHorizontal16: {
      marginHorizontal: 16,
    },
    marginHorizontal8: {
      marginHorizontal: 8,
    },
    flexDirectionRow: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    justifyContentSpaceBetween: {
      justifyContent: 'space-between',
    },
    webViewContainer: {
      flex: 1,
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      backgroundColor: colors.surface,
    },
    // Themed webview backdrop so dark mode doesn't flash white while the
    // external page loads (the page itself keeps its own colors — known gap).
    webView: {
      backgroundColor: colors.background,
    },
    fullScreen: {
      ...CommonStyles.full_width,
      ...CommonStyles.full_height,
    },
    headerTextContainer: {
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
    },
  });

export default makeStyles;
